import { render, staticRenderFns } from "./ActualitesWidget.vue?vue&type=template&id=7c553a34"
import script from "./ActualitesWidget.vue?vue&type=script&lang=js"
export * from "./ActualitesWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports